import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import store, { persistor } from "./app/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
import "./i18n";
import { ProviderSearch } from "./context/SearchContext";
import { MainProviderSearch } from "./context/MainSearchContext";
import { DependProviderSearch } from "./context/DependSearchContext";
import { InnerProviderSearch } from "./context/InnerSearchContext";
import { PrSpecProviderSearch } from "./context/PrSpecSearchContext";
import { PrAccesSearchContext } from "./context/PrAccesSearchContext";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorFallback } from "./components/errorFallback/errorFallback";
import CcRefProvider, {CcRefContext} from "./context/ccRefContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary FallbackComponent={ErrorFallback}>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <CcRefProvider>
          <ProviderSearch>
            <PrSpecProviderSearch>
              <PrAccesSearchContext>
                <MainProviderSearch>
                  <DependProviderSearch>
                    <InnerProviderSearch>
                      <BrowserRouter>
                        <React.StrictMode>
                          <App />
                        </React.StrictMode>
                      </BrowserRouter>
                    </InnerProviderSearch>
                  </DependProviderSearch>
                </MainProviderSearch>
              </PrAccesSearchContext>
            </PrSpecProviderSearch>
          </ProviderSearch>
        </CcRefProvider>
      </PersistGate>
    </Provider>
  </ErrorBoundary>
);
